import { useState, useEffect, useCallback, useRef } from "react";
import NavBar from "../../../common/navbar";
import { baseUrl, getRequestOptions, postRequestOptions, handleAuth, getAxiosRequestOptions } from "../../../common/cookie";
import Loader from "../../../common/loader";
import axios from "axios";
import { getDate, formatDate, getDateTimeInMongoDBCollectionFormat, getDateFromInput, CopyableCell, getDurationName } from "../../../common/functions";
import { useLocation } from "react-router-dom";
import * as XLSX from "xlsx";

import { editTitlesBO, longTitlesBO, mediumTitlesBO, smallTitlesBO, tableTitlesBackOffice, wideValueTitlesBO } from "../tools/titlesPortfolio";
import ViewSummaryFund from "../../frontOffice/portfolio/moreInfoTable";
import PlTable from "../../frontOffice/portfolio/plTable";
import FilterCard from "../../frontOffice/tools/filterCard";
import { unEditableTitlesBO } from "../tools/titlesPortfolio";
import EditPosition from "../tools/editPosition";
import CorporateAction from "../tools/corporateAction";
import HidePosition from "../tools/hidePosition";
import ViewRlzdTrades from "../tools/viewRlzdTrades";
import ViewSettlement from "../tools/viewSettlement";
import ViewTradeHistory from "../tools/viewTradeHistory";
import ViewDealerRuns from "../tools/viewDealerRuns";

export let widthScreen: any = {
  0: "0px",
  1: "50px",
  2: "100px",
  3: "150px",
  4: "200px",
  5: "280px",
  6: "330px",
  7: "380px",
  8: "430px",
  9: "510px",
};
export let widthMobile: any = {
  0: "0px",
  1: "17px",
  2: "34px",
  3: "51px",
  4: "68px",
  5: "108px",
  6: "138px",
  7: "168px",
  8: "198px",
  9: "238px",
};

function ViewReport() {
  let [portfolio, setPortfolio] = useState<any>();
  let [filteredPortfolio, setFilteredPortfolio] = useState<any>();
  let [lastPriceUpdate, setPriceLastUpdate] = useState("");
  let [lastTradeUpload, setTradeLastUpload] = useState("");
  let [positionInfoDisplay, setPositionInfoDisplay] = useState("none");
  let [positionInfo, setPositionInfo] = useState<any>([]);
  let [filterCardDisplay, setFilterCardDisplay] = useState("none");
  let [rlzdTradesCardDisplay, setRlzdTradesCardDisplay] = useState("none");
  let [settlementCardDisplay, setSettlementCardDisplay] = useState("none");
  let [tradeHistoryCardDisplay, setTradeHistoryCardDisplay] = useState("none");
  let [dealerRunsCardDisplay, setDealerRunsCardDisplay] = useState("none");
  let [corporateActionDisplay, setCorporateActionDisplay] = useState("none");
  let [hidePositionDisplay, setHidePositionDisplay] = useState("none");

  let [authStatus, setAuthStatus] = useState("");
  let query = new URLSearchParams(useLocation().search);
  let [yieldParam, setYieldParam] = useState(query.get("yield"));

  let [country, setCountry] = useState(query.get("country"));
  let [sector, setSector] = useState(query.get("sector"));
  let [strategy, setStrategy] = useState(query.get("strategy"));
  let [durationStart, setDurationStart]: any = useState(query.get("duration_start"));
  let [durationEnd, setDurationEnd]: any = useState(query.get("duration_end"));
  let [coupon, setCoupon] = useState(query.get("coupon"));
  let [assetClass, setAssetClass] = useState(query.get("assetClass"));
  let [rating, setRating] = useState(query.get("rating"));
  let [marketType, setMarketType] = useState(query.get("marketType"));
  let [region, setRegion] = useState(query.get("region"));
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  let headerRowRef = useRef<HTMLTableRowElement>(null);
  let [stickyOffsets, setStickyOffsets] = useState<any>(widthScreen);

  useEffect(() => {
    if (!headerRowRef.current || screenWidth < 1000) return;
    let cells = Array.from(headerRowRef.current.children) as HTMLElement[];
    let offset = 0;
    let offsets: any = {};
    for (let i = 0; i < Math.min(10, cells.length); i++) {
      offsets[i] = offset + "px";
      offset += cells[i].getBoundingClientRect().width;
    }
    setStickyOffsets(offsets);
  }, [filteredPortfolio, screenWidth]);

  let [issuer, setIssuer]: any = useState(query.get("issuer"));
  let [currency, setCurrency]: any = useState(query.get("currency"));
  let longShort = query.get("longShort");
  let [filterText, setFilterText] = useState<any>([]);
  let [sort, setSort] = useState(query.get("sort"));
  let newSign: any = query.get("newSign");
  let title: any = query.get("title");
  let ticker: any = query.get("ticker");
  let dateSort: any = query.get("dateSort");
  let [dateQuery, setDateQuery]: any = useState(query.get("date"));
  const [request, setRequestStatus] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false); 
  

  let [summary, setSummary] = useState<any>({});
  let today: any;
  if (dateQuery) {
    today = getDateTimeInMongoDBCollectionFormat(new Date(new Date(dateQuery).getTime() + 60 * 1000));
  } else {
    today = getDateTimeInMongoDBCollectionFormat(new Date(new Date().getTime() + 60 * 1000));
  }
  let [date, setDate] = useState(today);
  let url: any = baseUrl + `portfolio?date=${today}&sort=order&sign=1`;
  let [reportName, setReportName] = useState(today);
  let [unEditableParams, setUnEditableParams] = useState(unEditableTitlesBO);
  let [searchText, setSearchText] = useState("");

  if (country) {
    url += "&country=" + country;
  }
  if (sector) {
    url += "&sector=" + sector;
  }
  if (strategy) {
    url += "&strategy=" + strategy;
  }
  if (durationStart) {
    url += "&durationStart=" + durationStart;
  }
  if (durationEnd) {
    url += "&durationEnd=" + durationEnd;
  }
  if (currency) {
    url += "&currency=" + currency;
  }
  if (issuer) {
    url += "&issuer=" + issuer;
  }
  if (longShort) {
    url += "&longShort=" + longShort;
  }
  if (ticker) {
    url += "&ticker=" + ticker;
  }
  if (assetClass) {
    url += "&assetClass=" + assetClass;
  }
  if (coupon) {
    url += "&coupon=" + coupon;
  }
  if (yieldParam) {
    url += "&yield=" + yieldParam;
  }

  if (rating) {
    url += "&rating=" + rating;
  }
  if (region) {
    url += "&region=" + region;
  }
  if (marketType) {
    url += "&marketType=" + marketType;
  }

  console.log("Constructed API URL:", url);

  const filterByFXPNL = () => {
    if (isFiltered) {
      // Reset to the original portfolio
      setFilteredPortfolio(portfolio);
      setIsFiltered(false); // Set to unfiltered state
    } else {
      // Apply the filter
      const filtered = portfolio.filter(
        (bond: any) => bond["Day P&L FX"] && bond["Day P&L FX"] !== 0
      );
      setFilteredPortfolio(filtered);
      setIsFiltered(true); // Set to filtered state
    }
  };

  function fetchAndMergeDealerRuns(loadedPortfolio: any) {
    let dealerRunsUrl = baseUrl + `dealer-runs?date=${today}&portfolioId=portfolio_main`;
    fetch(dealerRunsUrl, getRequestOptions)
      .then((res) => {
        handleAuth(res.status);
        return res.json();
      })
      .then((data) => {
        if (data.error || !data.dealerRuns || !loadedPortfolio) {
          return;
        }
        let dealerRuns = data.dealerRuns;
        for (let position of loadedPortfolio) {
          let key = `${position["ISIN"]}_${position["Location"]}`;
          let match = dealerRuns[key];
          if (!match) {
            continue;
          }
          // Kept off the main table on purpose - dealer run detail only surfaces in the
          // "View Dealer Runs" drill-down modal, not as extra header columns.
          position["__dealerRunQuotes"] = match.quotes;
          position["__dealerRunMatchMethod"] = match.matchMethod;
          position["__dealerRunCount"] = match.quoteCount;
        }
        setPortfolio([...loadedPortfolio]);
        setFilteredPortfolio([...loadedPortfolio]);
      })
      .catch((error) => {
        console.error("Error fetching dealer runs:", error);
      });
  }

  useEffect(() => {
    fetch(url, getRequestOptions)
      .then((res) => {
        console.log("Response Status:", res.status);
        handleAuth(res.status);
        return res.json();
      })
      .then((data) => {
        console.log("API Response Data:", data);
        if (data.error) {
          setPortfolio([]);
          setFilteredPortfolio([]);
          setRequestStatus(false);
        } else {
          setTradeLastUpload(formatDate(data.uploadTradesDate));
          setPortfolio(data.portfolio);
          setFilteredPortfolio(data.portfolio);
          fetchAndMergeDealerRuns(data.portfolio);

          let filtered = data.portfolio;
          let text = [];
          if (country) {
            text.push("Country: " + country.replace(/@/g, " & "));
          }

          if (sector) {
            text.push("Sector: " + sector.replace(/@/g, " & "));
          }
          if (strategy) {
            text.push("Strategy: " + strategy.replace(/@/g, " & "));
          }
          if (durationStart) {
            if (!durationEnd) {
              durationEnd = "100 years";
            }
            durationStart = getDurationName(durationStart);
            durationEnd = getDurationName(durationEnd);

            text.push("Duration: " + durationStart + " - " + durationEnd);
          }

          if (issuer) {
            text.push("Issuer: " + issuer.replace(/@/g, " & "));
          }
          if (ticker) {
            text.push("BB Ticker: " + ticker.replace(/@/g, " & "));
          }
          if (currency) {
            text.push("Currency: " + currency.replace(/@/g, " & "));
          }
          if (assetClass) {
            text.push("Asset Class: " + assetClass.replace(/@/g, " & "));
          }
          if (coupon) {
            text.push("Coupon: > " + coupon);
          }
          if (yieldParam) {
            text.push("Yield To Maturity: > " + yieldParam);
          }
          if (rating) {
            text.push("Rating: " + rating.replace(/@/g, " & "));
          }
          if (region) {
            text.push("Region: " + region.replace(/@/g, " & "));
          }
          if (marketType) {
            text.push("Market Class: " + marketType.replace(/@/g, " & "));
          }
          console.log("Filter Text:", text);
          setFilteredPortfolio(filtered);
          setSummary(data);
          setFilterText(text);

          if (data.portfolio.length > 0) {
            try {
              setPriceLastUpdate(formatDate(data.updatePriceDate));
            } catch (error) {
              setPriceLastUpdate("");
            }
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching portfolio data:", error);
        setPortfolio([]);
        setFilteredPortfolio([]);
      });

    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [contextMenuState, setContextMenuState] = useState({
    visible: false,
    x: 0,
    y: 0,
  });
  const contextMenuRef: any = useRef(null);

  const handleContextMenu = useCallback((event: any, issue: any) => {
    event.preventDefault();

    const scrollX = window.scrollX || window.pageXOffset;
    const scrollY = window.scrollY || window.pageYOffset;

    // Calculate the position of the context menu accounting for the scroll
    const x = event.clientX + scrollX;
    const y = event.clientY + scrollY;

    setPositionInfo(issue);
    setContextMenuState({
      visible: true,
      x: x,
      y: y,
    });
  }, []);

  const handleClick = useCallback((event: any) => {
    // Hide context menu if clicking outside
    if (contextMenuRef.current && !contextMenuRef.current.contains(event.target)) {
      setContextMenuState({ visible: false, x: 0, y: 0 });
    }
  }, []);

  function handleViewRlzdMtd(event: any, position: any) {
    setPositionInfo(position);
    setRlzdTradesCardDisplay("block");
  }
  function handleViewSettlement(event: any, position: any) {
    setPositionInfo(position);
    setSettlementCardDisplay("block");
  }

  function handleViewTradeHistory(event: any, position: any) {
    setPositionInfo(position);
    setTradeHistoryCardDisplay("block");
  }

  function handleViewDealerRuns(event: any, position: any) {
    setPositionInfo(position);
    setDealerRunsCardDisplay("block");
  }

  // Records the PM's choice of dealer price on the position - kept internal (not a
  // table column) so it's available if/when this needs to feed a pricing/trade workflow.
  function handleSelectDealerPrice(position: any, selection: any) {
    position["__selectedDealerPrice"] = selection;
  }

  async function queryPortfolio(event: any) {
    let newDate = getDateTimeInMongoDBCollectionFormat(date);
    setReportName(newDate);
    window.location.href = `view-portfolio?date=${newDate}`;
  }
  async function handleDeletePosition(event: any) {
    setRequestStatus(true);
    event.preventDefault();

    let formData: any = new FormData();

    // Append the date to the FormData object with the desired key
    console.log(positionInfo);
    formData.append("data", JSON.stringify(positionInfo));
    let currentDate: string = new Date(reportName).toISOString();

    // Append the date to the FormData object with the desired key
    formData.append("date", currentDate);
    let confirm = window.confirm("Confirm delete position " + positionInfo["BB Ticker"] + " with location code: " + positionInfo["Location"]);
    if (confirm) {
      try {
        let auth: any = await axios.post(baseUrl + "delete-position", formData, postRequestOptions);

        if (!auth.data.error) {
          window.location.href = "/view-portfolio?date=" + reportName;
        } else {
          setRequestStatus(false);
          window.alert(`${auth.data.error}`);
        }
        setRequestStatus(false);
      } catch (error) {
        setAuthStatus("error");
      }
    } else {
      setRequestStatus(false);
    }
  }

  async function handleRecalculatePosition(event: any) {
    setRequestStatus(true);
    event.preventDefault();

    let formData: any = new FormData();
    let currentDate: string = new Date(reportName).toISOString();
    // Append the date to the FormData object with the desired key
    let tradeType = "vcons";
    let identifier = positionInfo["ISIN"];
    let cdsCheck = positionInfo["Type"];
    if (identifier.includes("IB")) {
      tradeType = "ib";
    } else if (identifier.includes("1393")) {
      tradeType = "emsx";
    } else if (cdsCheck.includes("CDS")) {
      tradeType = "gs";
    }
    formData.append("date", currentDate);
    formData.append("ISIN", positionInfo["ISIN"]);
    formData.append("Location", positionInfo["Location"]);
    formData.append("tradeType", tradeType);

    let confirm = window.confirm("Confirm recalculate position " + positionInfo["BB Ticker"] + " with location code: " + positionInfo["Location"]);
    if (confirm) {
      try {
        let auth: any = await axios.post(baseUrl + "recalculate-position", formData, postRequestOptions);

        if (!auth.data.error) {
          window.location.href = "/view-portfolio?date=" + currentDate;
        } else {
          setRequestStatus(false);
          window.alert(`${auth.data.error}`);
        }
        setRequestStatus(false);
      } catch (error) {
        setAuthStatus("error");
      }
    }
    setRequestStatus(false);
  }

  function downloadCSV() {
    let table = document.getElementById("table-id");

    // Use XLSX.utils.table_to_book to convert the table to a workbook
    let wb = XLSX.utils.table_to_book(table, { sheet: "Sheet 1" });

    // Write the workbook to a file
    XLSX.writeFile(wb, `portfolio_${reportName}.xlsx`);
  }

  function getTrades(event: any) {
    let issue = positionInfo["BB Ticker"];
    let isin = positionInfo["ISIN"];
    let location = positionInfo["Location"];
    let tradeType = "vcons";
    let identifier = isin ? isin : issue;
    let assetClass = positionInfo["Type"];

    if (isin.includes("IB")) {
      tradeType = "ib";
    } else if (issue.includes("1393")) {
      tradeType = "emsx";
    } else if (assetClass.includes("CDS")) {
      tradeType = "gs";
    }
    window.location.href = `/view-trades?identifier=${identifier}&location=${location}&tradeType=${tradeType}`;
  }

  function cancelPositionInfo(event: any) {
    setPositionInfoDisplay("none");
    setAuthStatus("");
  }

  function displayPositionEditInfo(event: any) {
    let todayDate = getDate();
    let setDate = getDateFromInput(date);
    if (todayDate == setDate) {
      setPositionInfoDisplay("flex");
    } else {
      setPositionInfoDisplay("flex");
    }
  }

  async function handleEditPosition(event: any) {
    setRequestStatus(true);
    event.preventDefault();

    let formData: any = new FormData(event.target);
    let currentDate: string = new Date(reportName).toISOString();

    // Append the date to the FormData object with the desired key
    formData.append("date", currentDate);

    try {
      let auth = await axios.post(baseUrl + "edit-position", formData, postRequestOptions);

      if (auth.status == 200) {
        window.location.href = "/view-portfolio?date=" + currentDate;
      } else {
        setAuthStatus(auth.data.error);
        setRequestStatus(false);
      }
    } catch (error) {
      setAuthStatus("error");
      setRequestStatus(false);
    }
  }

  function displayCorporateAction(event: any) {
    setCorporateActionDisplay("flex");
    setContextMenuState({ visible: false, x: 0, y: 0 });
  }

  function cancelCorporateAction(event: any) {
    setCorporateActionDisplay("none");
    setAuthStatus("");
  }

  async function handleCorporateAction(event: any) {
    setRequestStatus(true);
    event.preventDefault();

    let formData: any = new FormData(event.target);
    let currentDate: string = new Date(reportName).toISOString();
    formData.append("date", currentDate);

    let bbTicker = positionInfo["BB Ticker"] || "";
    let notional = positionInfo["Notional Amount"] || 0;
    let selectedAction = formData.get("actionType") || "maturity_redemption";

    let confirmMessage = "";
    if (selectedAction == "bond_default") {
      let newCoupon = formData.get("newCouponRate") || "0";
      confirmMessage = "Confirm bond default for " + bbTicker + "?\nCoupon rate will change to " + newCoupon + "%.\nPosition remains open (Notional: " + parseFloat(notional).toLocaleString() + ").";
    } else if (selectedAction == "partial_redemption") {
      let redeemAmt = formData.get("redeemAmount") || "0";
      confirmMessage = "Confirm partial redemption of " + parseFloat(redeemAmt).toLocaleString() + " for " + bbTicker + "?\nRemaining notional: " + (parseFloat(notional) - parseFloat(redeemAmt)).toLocaleString();
    } else if (selectedAction == "pik_coupon_payment") {
      let cashCpn = formData.get("cashCoupon") || "0";
      let pikCpn = formData.get("pikCoupon") || "0";
      confirmMessage = "Confirm PIK coupon payment for " + bbTicker + "?\nCash Coupon: " + cashCpn + "%, PIK Coupon: " + pikCpn + "%\nNotional will increase by PIK accrual.";
    } else if (selectedAction == "debt_restructuring") {
      let tenderedAmt = formData.get("tenderedAmount") || "0";
      let treatment = formData.get("costBasisTreatment") || "carry_over";
      let sinkExtra = formData.get("writeDownPrice");
      let partialExtra = formData.get("redeemAmount");
      let sinkLine = sinkExtra && String(sinkExtra).trim() != "" && parseFloat(sinkExtra as string) > 0 ? "\nSink factor reduction: " + parseFloat(sinkExtra as string).toLocaleString() : "";
      let partialLine = partialExtra && String(partialExtra).trim() != "" && parseFloat(partialExtra as string) > 0 ? "\nPartial redemption: " + parseFloat(partialExtra as string).toLocaleString() : "";
      let outturnsRaw = formData.get("outturns") || "[]";
      let outturnsList: any[] = [];
      try { outturnsList = JSON.parse(outturnsRaw as string); } catch (e) { outturnsList = []; }
      let hasOutturns = outturnsList.length > 0;
      let outturnLines = hasOutturns ? "\nTendered: " + parseFloat(tenderedAmt as string).toLocaleString() + "\nOutturns:\n" + outturnsList.map((o: any, i: number) => `  ${i + 1}. ${o.bbTicker || "?"} (${o.isin || "?"}) notional ${parseFloat(o.newNotional || "0").toLocaleString()} @ ${o.day1Mid || "?"}`).join("\n") : "\nNo outturns (sink/partial only)";
      confirmMessage = "Confirm Debt Restructuring for " + bbTicker + "?" + sinkLine + partialLine + "\nCost basis treatment: " + treatment + outturnLines;
    } else {
      confirmMessage = "Confirm redemption for " + bbTicker + " (Notional: " + parseFloat(notional).toLocaleString() + ")?\nThis will close the position and create a trade record.";
    }

    let confirmed = window.confirm(confirmMessage);

    if (confirmed) {
      try {
        let auth: any = await axios.post(baseUrl + "corporate-action", formData, postRequestOptions);

        if (auth.data && auth.data.error) {
          setAuthStatus(auth.data.error);
          setRequestStatus(false);
        } else {
          window.location.href = "/view-portfolio?date=" + currentDate;
        }
      } catch (error: any) {
        let msg = error && error.response && error.response.data && error.response.data.error ? error.response.data.error : "error";
        setAuthStatus(msg);
        setRequestStatus(false);
      }
    } else {
      setRequestStatus(false);
    }
  }

  function displayHidePosition(event: any) {
    setHidePositionDisplay("flex");
    setAuthStatus("");
    setContextMenuState({ visible: false, x: 0, y: 0 });
  }

  function cancelHidePosition(event: any) {
    setHidePositionDisplay("none");
    setAuthStatus("");
  }

  async function handleHidePosition(event: any, reason: string) {
    event.preventDefault();
    if (!reason || reason.trim() == "") {
      setAuthStatus("Reason is required");
      return;
    }

    let ticker = positionInfo["BB Ticker"] || "";
    let isin = positionInfo["ISIN"] || "";
    let location = positionInfo["Location"] || "";

    setRequestStatus(true);
    setHidePositionDisplay("none");
    try {
      let payload = {
        "BB Ticker": ticker,
        "ISIN": isin,
        "Location": location,
        "reason": reason,
        "positionData": positionInfo
      };
      let action: any = await axios.post(baseUrl + "hide-position", payload, postRequestOptions);
      handleAuth(action.status);
      if (action.data && action.data.error) {
        setAuthStatus(action.data.error);
        setRequestStatus(false);
      } else {
        window.location.href = "/stale-positions";
      }
    } catch (error) {
      setAuthStatus("error");
      setRequestStatus(false);
    }
  }

  function onChangePositionFilter(event: any) {
    let value = event.target.value;
    setSearchText(value);
    let searchTerms = value.toLowerCase().split(" ");
    let matchedLocationCodes = new Set();

    // Step 1: Filter positions based on search terms and collect Location codes
    portfolio.forEach((position: any) => {
      if (!position) return;

      // Check if each property exists and includes any of the searchTerms
      let conditions = searchTerms.every((searchTerm: any) => Object.keys(position).some((key) => position[key]?.toString().toLowerCase().includes(searchTerm)));

      // If conditions are met, add the Location to matchedLocationCodes
      if (conditions) {
        matchedLocationCodes.add(position["Location"]);
      }
    });

    // Step 2: Include positions that match the search terms or share a Location with the matched positions
    let filteredAndIncludedPositions = portfolio.filter((position: any) => {
      if (!position) return false;

      // Check if this position's Location is in the set of matched Location codes
      let locationMatch = matchedLocationCodes.has(position["Location"]);

      // If the position matches the search terms or shares a Location, include it
      return locationMatch;
    });

    // filteredAndIncludedPositions now contains the filtered positions in the original order

    setFilteredPortfolio(filteredAndIncludedPositions);
  }

  function handleSearchTradeHistory(event: any) {
    if (!searchText.trim()) {
      window.alert("Please enter ISIN, Location code, or BB Ticker to search");
      return;
    }

    let searchTerms = searchText.toLowerCase().split(" ");
    let matchedPosition: any = null;

    // Find the first matching position
    if (portfolio && portfolio.length > 0) {
      for (let i = 0; i < portfolio.length; i++) {
        let position = portfolio[i];
        if (!position) continue;

        let conditions = searchTerms.every((searchTerm: any) => 
          Object.keys(position).some((key) => 
            position[key]?.toString().toLowerCase().includes(searchTerm)
          )
        );

        if (conditions) {
          matchedPosition = position;
          break;
        }
      }
    }

    if (matchedPosition) {
      setPositionInfo(matchedPosition);
      setTradeHistoryCardDisplay("block");
    } else {
      // For closed positions or positions not in current portfolio
      // Create a search object with the search text
      let searchValue = searchText.trim();
      let searchPosition: any = {};
      
      // Detect if search is ISIN (exactly 12 alphanumeric chars), Location code, or BB Ticker
      let hasSpace = searchValue.includes(" ");
      let hasDot = searchValue.includes(".");
      let hasDigit = /\d/.test(searchValue);
      if (/^[A-Z]{2}[A-Z0-9]{10}$/i.test(searchValue)) {
        // ISIN: exactly 12 chars, 2-letter country code + 10 alphanumeric
        searchPosition["ISIN"] = searchValue.toUpperCase();
        searchPosition["Location"] = "";
        searchPosition["BB Ticker"] = "";
      } else if (!hasSpace && !hasDot && hasDigit && searchValue.length <= 10) {
        // Location code: short, no spaces/dots, contains at least one digit
        // Covers B429, EM-1, EQ001, GS-1, IB001, etc.
        searchPosition["ISIN"] = "";
        searchPosition["Location"] = searchValue.toUpperCase();
        searchPosition["BB Ticker"] = "";
      } else {
        // BB Ticker: has spaces, dots, or is a longer string
        searchPosition["ISIN"] = "";
        searchPosition["Location"] = "";
        searchPosition["BB Ticker"] = searchValue;
      }
      
      setPositionInfo(searchPosition);
      setTradeHistoryCardDisplay("block");
    }
  }

  function handleSearchKeyPress(event: any) {
    if (event.key === "Enter") {
      handleSearchTradeHistory(event);
    }
  }

  if (portfolio == null) {
    return (
      <div>
        <NavBar />
        <Loader />
      </div>
    );
  } else if (portfolio.length == 0 || portfolio == null) {
    return (
      <div>
        <NavBar />
        <div className="portfolio-range-updates-container">
          <div>
            <h4 className="lastUpdateText">Last Prices Update: {lastPriceUpdate}</h4>
            <h4 className="lastUpdateText">Last Trade Upload: {lastTradeUpload}</h4>
          </div>
          <div className="portfolio-range-picker-container input-search-calendar-container">
            <div className="search-container portfolio-search-container">
              <input
                className="form-control mr-sm-2 filter-trades-search-bar filter-portfolio-search-bar"
                type="search"
                placeholder="Search Position By BB Ticker, ISIN, or Location code (Press Enter for Trade History)"
                aria-label="Search"
                onChange={(event) => {
                  onChangePositionFilter(event);
                }}
                onKeyPress={(event) => {
                  handleSearchKeyPress(event);
                }}
              />
              <button className="btn upload-btn no-flex" style={{ marginLeft: "5px" }} onClick={(event) => handleSearchTradeHistory(event)}>
                View History
              </button>
            </div>
            <input title="date" type="datetime-local" className="input-calendar" value={date} onChange={(event: any) => setDate(event.target.value)} />
            <button className="btn upload-btn no-flex" onClick={(event) => queryPortfolio(event)}>
              Query
            </button>
          </div>
        </div>
        <div>
          {filterText.length ? (
            <div className="filter-params">
              <p className="title-unassigned">Filtered</p>{" "}
              <button className="btn upload-btn no-flex btn-clear" onClick={(event) => (window.location.href = "/view-portfolio")}>
                Clear
              </button>
            </div>
          ) : (
            ""
          )}
          <ul className="list-filter">
            {filterText.map((text: any, index: any) => (
              <li>{text}</li>
            ))}
          </ul>
        </div>
        <div className="title">
          <h4>No Record</h4>
        </div>

        <div style={{ display: tradeHistoryCardDisplay }} onDoubleClick={(event) => setTradeHistoryCardDisplay("none")}>
          {!positionInfo || (!positionInfo["ISIN"] && !positionInfo["Location"] && !positionInfo["BB Ticker"]) ? "" : <ViewTradeHistory setTradeHistoryCardDisplay={setTradeHistoryCardDisplay} positionInfo={positionInfo} date={date} />}
        </div>
      </div>
    );
  } else if (request) {
    return (
      <div>
        <NavBar />
        <Loader />
      </div>
    );
  } else {
    return (
      <div>
        <NavBar />

        <div className="portfolio-range-updates-container">
          <div>
            <h4 className="lastUpdateText">Last Prices Update: {lastPriceUpdate}</h4>
            <h4 className="lastUpdateText">Last Trade Upload: {lastTradeUpload}</h4>
          </div>
          <div className="portfolio-range-picker-container input-search-calendar-container">
            <div className="search-container portfolio-search-container">
              <input
                className="form-control mr-sm-2 filter-trades-search-bar filter-portfolio-search-bar"
                type="search"
                placeholder="Search Position By BB Ticker, ISIN, or Location code (Press Enter for Trade History)"
                aria-label="Search"
                onChange={(event) => {
                  onChangePositionFilter(event);
                }}
                onKeyPress={(event) => {
                  handleSearchKeyPress(event);
                }}
              />
              <button className="btn upload-btn no-flex" style={{ marginLeft: "5px" }} onClick={(event) => handleSearchTradeHistory(event)}>
                View History
              </button>
            </div>
            <input title="date" type="datetime-local" className="input-calendar" value={date} onChange={(event: any) => setDate(event.target.value)} />
            <button className="btn upload-btn no-flex" onClick={(event) => queryPortfolio(event)}>
              Query
            </button>
          </div>
        </div>

        <ViewSummaryFund summary={summary} titles={tableTitlesBackOffice} queryPortfolio={queryPortfolio} setFilterCardDisplay={setFilterCardDisplay} url={"/view-portfolio?"} date={date} statistics={true} filter={true} filterByFXPNL={filterByFXPNL}  />
        {/* <PlTable fundDetails={summary} analysis={summary.analysis} filterByFXPNL={filterByFXPNL} /> */}
        <div>
          {filterText.length ? (
            <div className="filter-params">
              <p className="title-unassigned">Filtered</p>{" "}
              <button className="btn upload-btn no-flex btn-clear" onClick={(event) => (window.location.href = "/view-portfolio")}>
                Clear
              </button>
            </div>
          ) : (
            ""
          )}
          <ul className="list-filter">
            {filterText.map((text: any, index: any) => (
              <li>{text}</li>
            ))}
          </ul>
        </div>
        <div
          className="table-container-custom"
          style={{
            overflowX: "auto",
          }}
        >
          <table id="table-id" onClick={handleClick} className="table table-hover table-portfolio">
            <tbody>
              <tr ref={headerRowRef} className="sticky-top">
                {tableTitlesBackOffice.map((title: any, titleIndex: any) => {
                  // Check if the title is one of the specified strings

                  // If you need to keep the table structure consistent, render an empty <td>
                  return (
                    <td
                      key={titleIndex}
                      className={
                        "copied-text " +
                        (titleIndex < 10 ? " higher-sticky-row " : " lower-sticky-row ") +
                        (titleIndex < 10 ? " higher-sticky-portfolio-row  " : "") +
                        (longTitlesBO.includes(title) ? " wider-table-cell" : "") +
                        (longTitlesBO.includes(title) ? " wider-table-cell" : "") +
                        (smallTitlesBO.includes(title) ? " small-table-cell" : "") +
                        (mediumTitlesBO.includes(title) ? " medium-table-cell" : "") +
                        (wideValueTitlesBO.includes(title) ? " value-table-cell" : "")
                      }
                      style={{ left: screenWidth < 1000 ? widthMobile[titleIndex] : stickyOffsets[titleIndex] }}
                    >
                      {title}
                    </td>
                  );
                })}
              </tr>
              {filteredPortfolio.map((position: any, index: number) => (
                <tr
                  key={index}
                  onContextMenu={(event) => handleContextMenu(event, position)}
                  className={"table-body " + (position["Type"] && position["Type"].includes("Total") ? " borders" : "")}
                  style={{
                    backgroundColor: `${position["Color"]}`,
                    borderBottom: position["bottom"] ? "2px solid grey" : "",

                    cursor: "pointer",
                  }}
                >
                  {tableTitlesBackOffice.map((title: string, index: number) => {
                      let cellValue =
                        title === "Amortized Notional Value"
                          ? position["Type"] === "BND"
                            ? position["Principal"]
                            : "x"
                          : position[title];

                      if (title === "BB Ticker" && position["__dealerRunCount"] > 0) {
                        return (
                          <td
                            key={index}
                            onClick={() => navigator.clipboard.writeText(cellValue)}
                            style={{ cursor: "pointer", position: "relative", backgroundColor: position["Color"], left: screenWidth < 1000 ? widthMobile[index] : stickyOffsets[index] }}
                            className={"copied-text " + (index < 10 ? " sticky-portfolio" : "")}
                          >
                            {cellValue}
                            <span
                              title={`${position["__dealerRunCount"]} dealer quote${position["__dealerRunCount"] === 1 ? "" : "s"}`}
                              onClick={(event) => { event.stopPropagation(); handleViewDealerRuns(event, position); }}
                              style={{
                                display: "inline-block",
                                width: "6px",
                                height: "6px",
                                borderRadius: "50%",
                                backgroundColor: "#144276",
                                marginLeft: "4px",
                                cursor: "pointer",
                              }}
                            />
                          </td>
                        );
                      }

                      return (
                        <CopyableCell
                          key={index}
                          text={
                            isFinite(cellValue) && cellValue
                              ? cellValue.toLocaleString()
                              : cellValue
                          }
                          index={index}
                          columns={10}
                          type={"portfolio"}
                          color={position["Color"]}
                          left={screenWidth < 1000 ? widthMobile[index] : stickyOffsets[index]}
                        />
                      );
                    })}


                </tr>
              ))}
              {contextMenuState.visible && (
                <div
                  ref={contextMenuRef}
                  style={{
                    position: "absolute",
                    top: contextMenuState.y,
                    left: contextMenuState.x,
                  }}
                  className="context-menu-container"
                >
                  <div className="context-menu">
                    <div className="context-menue-row">
                      <p className="context-menu-text" onClick={(event) => displayPositionEditInfo(event)}>
                        Edit Position
                      </p>
                    </div>
                    <div className="context-menue-row">
                      <p className="context-menu-text" onClick={(event) => handleRecalculatePosition(event)}>
                        Recalculate Position
                      </p>
                    </div>

                    <div className="context-menue-row">
                      <p className="context-menu-text" onClick={(event) => handleDeletePosition(event)}>
                        Delete Position
                      </p>
                    </div>
                    <div className="context-menue-row">
                      <p className="context-menu-text" onClick={(event) => displayCorporateAction(event)}>
                        Corporate Action
                      </p>
                    </div>
                    <div className="context-menue-row">
                      <p className="context-menu-text" onClick={(event) => displayHidePosition(event)}>
                        Move to Stale Positions
                      </p>
                    </div>
                  </div>
                  <hr className="hr" />
                  <div className="context-menu">
                    <div className="context-menue-row">
                      <p className="context-menu-text" onClick={(event) => handleViewRlzdMtd(event, positionInfo)}>
                        View MTD Rlzd Trades
                      </p>
                    </div>
                  </div>
                  <div className="context-menu">
                    <div className="context-menue-row">
                      <p className="context-menu-text" onClick={(event) => handleViewSettlement(event, positionInfo)}>
                        View Settlement
                      </p>
                    </div>
                    <div className="context-menue-row">
                      <p className="context-menu-text" onClick={(event) => handleViewTradeHistory(event, positionInfo)}>
                        View Full Trade History
                      </p>
                    </div>
                    <div className="context-menue-row">
                      <p className="context-menu-text" onClick={(event) => getTrades(event)}>
                        View Trades
                      </p>
                    </div>
                    <div className="context-menue-row">
                      <p className="context-menu-text" onClick={(event) => handleViewDealerRuns(event, positionInfo)}>
                        View Dealer Runs
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </tbody>
          </table>
        </div>
        <button id="download-btn" onClick={downloadCSV} className="btn upload-btn">
          Download CSV
        </button>
        <div className="edit-info-container-1" style={{ display: positionInfoDisplay }} onDoubleClick={(event: any) => cancelPositionInfo(event)}>
          <EditPosition position={positionInfo} authStatus={authStatus} unEditableParams={unEditableParams} tableTitles={editTitlesBO} handleEditPosition={handleEditPosition} cancelPositionInfo={cancelPositionInfo} />
        </div>
        <div className="edit-info-container-1" style={{ display: corporateActionDisplay }} onDoubleClick={(event: any) => cancelCorporateAction(event)}>
          <CorporateAction position={positionInfo} authStatus={authStatus} onSubmit={handleCorporateAction} onCancel={cancelCorporateAction} />
        </div>
        <div className="edit-info-container-1" style={{ display: hidePositionDisplay }} onDoubleClick={(event: any) => cancelHidePosition(event)}>
          <HidePosition position={positionInfo} authStatus={authStatus} onSubmit={handleHidePosition} onCancel={cancelHidePosition} />
        </div>
        <div style={{ display: filterCardDisplay }} onDoubleClick={(event) => setFilterCardDisplay("none")}>
          {portfolio == null ? (
            ""
          ) : (
            <FilterCard
              countries={summary.analysis.countryNAVPercentage}
              currencies={summary.analysis.currencies}
              sectors={summary.analysis.sectorNAVPercentage}
              strategies={summary.analysis.strategyNAVPercentage}
              issuers={summary.analysis.issuerNAVPercentage}
              tickerTable={summary.analysis.tickerTable}
              ratings={summary.analysis.ratingNAVPercentage}
              regions={summary.analysis.regionNAVPercentage}
              marketTypes={summary.analysis.marketTypeNAVPercentage}
              setFilterCardDisplay={setFilterCardDisplay}
              url={"/view-portfolio?"}
            />
          )}
        </div>

        <div style={{ display: rlzdTradesCardDisplay }} onDoubleClick={(event) => setRlzdTradesCardDisplay("none")}>
          {portfolio == null || !positionInfo ? "" : <ViewRlzdTrades setRlzdTradesCardDisplay={setRlzdTradesCardDisplay} positionInfo={positionInfo} date={date} />}
        </div>
        <div style={{ display: settlementCardDisplay }} onDoubleClick={(event) => setSettlementCardDisplay("none")}>
          {portfolio == null || !positionInfo ? "" : <ViewSettlement setSettlementCardDisplay={setSettlementCardDisplay} positionInfo={positionInfo} date={date} />}
        </div>

        <div style={{ display: tradeHistoryCardDisplay }} onDoubleClick={(event) => setTradeHistoryCardDisplay("none")}>
          {portfolio == null || !positionInfo || (!positionInfo["ISIN"] && !positionInfo["Location"] && !positionInfo["BB Ticker"]) ? "" : <ViewTradeHistory setTradeHistoryCardDisplay={setTradeHistoryCardDisplay} positionInfo={positionInfo} date={date} />}
        </div>
        <div style={{ display: dealerRunsCardDisplay }} onDoubleClick={(event) => setDealerRunsCardDisplay("none")}>
          {portfolio == null || !positionInfo ? "" : <ViewDealerRuns setDealerRunsCardDisplay={setDealerRunsCardDisplay} positionInfo={positionInfo} onSelectPrice={handleSelectDealerPrice} />}
        </div>
      </div>
    );
  }
}
export default ViewReport;
